import { Constants } from '@pwc/pwc-deals-web-common';

const { SECTION_LAYOUT_TYPE: sectionLayoutConstants } = Constants;

const CONSTANTS = Object.freeze({
  LAYOUT_TO_ICON: {
    [sectionLayoutConstants.ONE_COLUMN]: '1-col-fw',
    [sectionLayoutConstants.ONE_COLUMN_80]: '1-col-l',
    [sectionLayoutConstants.ONE_COLUMN_60]: '1-col-m',
    [sectionLayoutConstants.ONE_COLUMN_40]: '1-col-s',
    [sectionLayoutConstants.TWO_COLUMN]: '2-col',
    [sectionLayoutConstants.ONE_COLUMN_OVERFLOW_AREA]: '2-col-text',
    [sectionLayoutConstants.TWO_COLUMN_L_40_1A_R_60_1A]: '2-col-narrow-l',
    [sectionLayoutConstants.TWO_COLUMN_L_67_1A_R_33_1A]: '2-col-narrow-r',
    [sectionLayoutConstants.TWO_COLUMN_L_80_1A_R_20_1A]: '2-col-ex-narrow-r',
    [sectionLayoutConstants.THREE_COLUMN]: '3-col',
    [sectionLayoutConstants.TWO_COLUMN_L_50_3A_R_50_1A]: '3-stacked-r-col',
    [sectionLayoutConstants.TWO_COLUMN_L_50_2A_R_50_1A]: 'stacked-r-col',
    [sectionLayoutConstants.TWO_COLUMN_L_67_2A_R_33_1A]: 'stacked-narrow-r-col',
    [sectionLayoutConstants.TWO_ROW_T_50_2A_B_50_1A]: 'stacked-2-blk-top',
    [sectionLayoutConstants.TWO_ROW_T_50_1A_B_50_2A]: 'stacked-2-blk-btm',
    [sectionLayoutConstants.TWO_ROW_T_80_1A_B_20_1A]: 'stacked-l-top',
    [sectionLayoutConstants.TWO_ROW_T_60_1A_B_40_1A]: 'stacked-m-top',
    [sectionLayoutConstants.TWO_ROW_T_20_1A_B_80_1A]: 'stacked-l-btm',
    [sectionLayoutConstants.TWO_COLUMN_TWO_ROW_50_2A_50_2A]: '4-blk-btm',
    [sectionLayoutConstants.TWO_COLUMN_TWO_ROW_67_2A_33_2A]:
      '4-blk-narrow-r-btm',
    [sectionLayoutConstants.THREE_COLUMN_TWO_ROW]: '6-blk-top',
    [sectionLayoutConstants.THREE_ROWS]: '3-columns-full-width',
  },
});

export default CONSTANTS;
